/**
 * Host-based product detection (PlateChase vs CostcoChase).
 */
export function isCostcoChaseHost() {
	if (typeof window === 'undefined') return false;
	const host = window.location.hostname;
	if (host === 'costcochase.com' || host === 'www.costcochase.com') return true;
	if (process.env.NODE_ENV === 'development') {
		const params = new URLSearchParams(window.location.search);
		if (params.get('product') === 'costco') return true;
		if (window.location.pathname.startsWith('/costco')) return true;
	}
	return false;
}

export function costcoSpaOrigin() {
	if (typeof window === 'undefined') return 'https://www.costcochase.com';
	return window.location.origin;
}
